<template>
<card>
    <forum
        container
        notitle
        noloading
        :forum="content.forum"
    />
</card>
</template>

<script>
import { mapGetters } from 'vuex';
import Card from '../../../../argon/components/Cards/Card';
import BaseDropdown from '../../../../argon/components/BaseDropdown';
import Forum from '../../../Forum';

export default {
    name: 'OptionsForum',
    components: {
        BaseDropdown,
        Card,
        Forum,
    },
    computed: mapGetters({
        content: 'CLASS_CONTENT',
    }),
};
</script>

<style lang="sass" scoped>
.drop
    padding: 10px 15px
    margin: 8px
    li
        margin: 6px
        padding: 6px 4px
        cursor: pointer
        background-color: white
        transition: all .35s
        &:hover
            filter: brightness(94%)
</style>
